import { type ReactElement, useCallback, useMemo, useState } from 'react';
import { TableButton } from '@direct-frontend/components';

/*
 * Нужен для ограничения количества строк в MiniGrid и увеличения "порциями"
 *
 * @example <MiniGrid>{useLimitedGridRows({ rows, limit: 10, step: 5 })}</MiniGrid>
 */
export const useLimitedGridRows = ({
    rows,
    limit = 10,
    step = Infinity,
}: {
    rows: ReactElement[];
    limit?: number;
    step?: number;
}) => {
    const [currentLimit, setCurrentLimit] = useState(limit);

    const onClick = useCallback(() => {
        setCurrentLimit(currentLimit + step);
    }, [currentLimit, step]);

    const limitedRows = useMemo(() => {
        const withShowMoreButton = currentLimit < rows.length;
        const limitedRows = rows.slice(0, currentLimit);

        if (withShowMoreButton) {
            limitedRows.push(
                <TableButton key="addButton" onClick={onClick}>
                    {step === Infinity ? 'Показать всё' : 'Показать ещё'}
                </TableButton>
            );
        }

        return limitedRows;
    }, [rows, currentLimit, onClick, step]);

    return limitedRows;
};
